module.exports = __webpack_public_path__ + "img/pic_10.ea351645.jpg";